const stylesDesktop = {
  contentContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "90%",
    maxWidth: '1440px',
    position: "relative",
    margin: '0 auto',
  },

  textContainer: {
    flex: 2.8,
    textAlign: "left",
    paddingRight: "clamp(1rem, 3vw, 2rem)",
    marginLeft: "clamp(-2rem, -5vw, -4rem)",
    zIndex: 8,
    marginTop: "clamp(3rem, 8vw, 7.2rem)",
  },

  logo: {
    width: "clamp(2.5rem, 5vw, 3.6875rem)",
    height: "auto",
  },

  heading: {
    fontSize: "clamp(2rem, 5vw, 4rem)",
    fontWeight: 200,
    lineHeight: "1.2",
    color: "#FFF",
    marginBottom: "clamp(0.8rem, 3vw, 1.4rem)",
    marginTop: "clamp(0.5rem, 2vw, 0.8rem)",
  },

  subheading: {
    fontSize: "clamp(1rem, 2vw, 1.5rem)",
    color: "rgba(217, 217, 217, 0.5)",
    marginBottom: "0",
  },

  subheadingHighlight: {
    color: "rgba(217, 217, 217, 0.9)",
  },

  heroArt: {
    marginTop: "clamp(4rem, 12vw, 10rem)",
    maxWidth: "100%",
    height: "auto",
    opacity: 0.5,
    transition: "transform 0.3s ease, background-color 0.3s ease",
  },

  heroArtHover: {
    transform: "scale(1.02)",
  },

  cardsContainer: {
    flex: 1,
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  cardGradient: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '98%',
    objectFit: 'cover',
    zIndex: 1,
  },

  card1Placeholder: {
    position: "absolute",
    right: "clamp(20%, 39%, 39%)",
    width: "clamp(15rem, 40vw, 39rem)",
    height: "clamp(8rem, 18vw, 18rem)",
    border: "1px solid rgba(200, 200, 200, 0.2)",
    borderRadius: "30px",
    zIndex: 2,
    transform: "rotate(-2.67deg)",
    marginTop: "clamp(-4rem, -12vw, -12rem)",
  },

  card2Placeholder: {
    position: "absolute",
    top: "clamp(30%, 40%, 40%)",
    right: "clamp(-5%, -14%, -14%)",
    width: "clamp(15rem, 45vw, 39rem)",
    height: "clamp(10rem, 22vw, 22rem)",
    border: "1px solid rgba(200, 200, 200, 0.2)",
    borderRadius: "30px",
    zIndex: 3,
    transform: "rotate(1.27deg)",
    marginTop: "clamp(0.2rem, 1vw, 0.65rem)",
  },

  animatedImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: "none",
    zIndex: 5,
  },  
  
  cardBlur: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: "30px",
    backdropFilter: 'blur(60px)',// <-- sempre inicia em 100px
    zIndex: 4,
  },
};

export default stylesDesktop;
